module.exports = __webpack_public_path__ + "static/media/SPRAY2.8e15a351.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY2.png
// module id = 284
// module chunks = 0